import addError from '../../../utils/error.jsx';

export function request(sportId, ladder) {
    return {
        type: 'LADDER_UPDATE_REQUEST',
        sportId,
        ladder
    };
}

export function error(sportId, errors) {
    addError(errors);

    return {
        type: 'LADDER_UPDATE_ERROR',
        errors,
        sportId
    };
}

export function finish(sportId, {prices}) {
    return {
        type: 'LADDER_UPDATE_FINISH',
        prices,
        sportId
    };
}
